import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import React from "react";
import {AMSTERDAM_OFFICE_ID} from "../../util/OfficePath";
import {UploadButton} from "./UploadButton";

export function UploadAmsterdamVisitReportButton() {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);

    return currentOfficeId === AMSTERDAM_OFFICE_ID ? (
        <UploadButton accept=".csv"/>
    ) : null;
}
